exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea{\r\n    font-size:12px;\r\n    font-family:\"Courier New\", Courier, monospace;\r\n}\r\n\r\n.nodeId{\r\n    font-weight: normal;\r\n    font-size:12px;\r\n    line-height: 50px;\r\n    padding-left:30px;\r\n    }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/node-info/node-info.component.css
// module id = ../../../../../src/app/node-info/node-info.component.css
// module chunks = 1